/** Allow five digits */
const POSTAL_CODE_REGEXP = /^\d{5}$/

/** Returns `true` if input string looks like a five-digit postal code */
export const isPostalCode = (input: string): boolean => POSTAL_CODE_REGEXP.test(input)
